import React, { Fragment, useCallback } from 'react';

import {
    CLAUSULA_OPERADOR,
    TIPO_FRETE
} from '../../../../../constants/configuracao-frete';

import { formatToReal } from '../../../../../config/Format';

import { ItemListContainer, TextContainer, Text, Exclude, X } from './styles';
import { FreteExcludeItem } from './FreteExclude';
import { Modal } from '../../../../../components-reactjs/Modal';
import { useToggle } from '../../../../../hooks/useToggle';

export const ItemListWithExclude = ({
    itemFrete,
    type,
    excludeHandler,
    disabled,
    index
}) => {
    const [toggleExclude, handleToggleExclude] = useToggle(false);

    const labelText = useCallback(() => {
        const { idClausulaOperador, vlCondicaoFrete } = itemFrete;
        if (type === TIPO_FRETE.KM) {
            return idClausulaOperador === CLAUSULA_OPERADOR.MENOR_IGUAL
                ? `Até ${vlCondicaoFrete}km: `
                : `A partir de ${vlCondicaoFrete}km: `;
        }

        if (type === TIPO_FRETE.VALOR) {
            return idClausulaOperador === CLAUSULA_OPERADOR.MENOR_IGUAL
                ? `Até R$ ${formatToReal(vlCondicaoFrete)}: `
                : `A partir de R$ ${formatToReal(vlCondicaoFrete)}: `;
        }
    }, [itemFrete]);

    return (
        <Fragment>
            <Modal isOpen={toggleExclude} setIsOpen={handleToggleExclude}>
                <FreteExcludeItem
                    title="Excluir condição de frete?"
                    itemFrete={itemFrete}
                    labelContent={`${labelText()} R$ ${formatToReal(itemFrete.vlFrete)}`}
                    index={index}
                    handleCloseModal={handleToggleExclude}
                    excludeHandler={excludeHandler}
                />
            </Modal>
            <ItemListContainer type="button" disabled={disabled}>
                <TextContainer>
                    <Text style={{ marginRight: 0 }}>{labelText() || ''}</Text>
                    <Text $bold>{`R$ ${formatToReal(itemFrete.vlFrete)}`}</Text>
                </TextContainer>
                <Exclude onClick={() => handleToggleExclude(true)}>
                    <X>✕</X>
                </Exclude>
            </ItemListContainer>
        </Fragment>
    );
};
